import { render } from "./app-icon.vue?vue&type=template&id=af3a8a40&scoped=true&ts=true"
import script from "./app-icon.vue?vue&type=script&lang=ts"
export * from "./app-icon.vue?vue&type=script&lang=ts"

import "./app-icon.vue?vue&type=style&index=0&id=af3a8a40&lang=scss&scoped=true"

import exportComponent from "D:\\shine\\shine-project\\dispatch-big-screen-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3a8a40"]])

export default __exports__